const menuItems = [
  {
    items: [
      {
        link: "/organizations",
        text: "Synergy Stats Administration",
        icon: "multi-color-icon-ingame",
        children: [
          {
            link: "/organizations",
            text: "Organizations",
            translation: "organizations",
            conditions: [
              { variable: "isAuthenticated", evaluator: true },
              { variable: "hasAccess", evaluator: true },
            ],
          },
        ],
      },
      {
        link: "/score-query",
        text: "Score query",
        icon: "multi-color-icon-ingame",
      },
      {
        link: "https://vm.%BASEDOMAIN%",
        text: "Video Stream Manager",
        icon: "multi-color-icon-video",
        conditions: [
          {
            variable: "products",
            key: "video_stream_manager",
            evaluator: true,
          },
        ],
      },
      {
        link: "https://pm.%BASEDOMAIN%",
        text: "Live Production Monitor",
        icon: "multi-color-icon-production",
        conditions: [
          {
            variable: "products",
            key: "live_production_monitor",
            evaluator: true,
          },
        ],
      },
      {
        link: "https://ca.%BASEDOMAIN%",
        text: "Competition Admin",
        icon: "multi-color-icon-competition",
        conditions: [
          {
            variable: "products",
            key: "Datacore_competition_admin",
            evaluator: true,
          },
        ],
      },
      {
        link: "https://evo.%BASEDOMAIN%",
        text: "EVO Admin",
        icon: "multi-color-icon-evo",
        conditions: [
          {
            variable: "products",
            key: "evo",
            evaluator: true,
          },
        ],
      },
      {
        link: "https://um.%BASEDOMAIN%",
        text: "User Manager",
        icon: "multi-color-icon-users",
        conditions: [{ variable: "products", key: "user_manager", evaluator: true }],
      },
      {
        link: "https://admin.dc.%BASEDOMAIN%",
        text: "Datacore Admin",
        icon: "multi-color-icon-datacore",
        conditions: [{ variable: "products", key: "datacore", evaluator: true }],
      },
      {
        link: "https://d45erdalr3dh.cloudfront.net/schedule-manager/",
        text: "Schedule Manager",
        icon: "multi-color-icon-schedule",
        conditions: [{ variable: "products", key: "s3_schedule_manager", evaluator: true }],
      },
      {
        link: "https://d45erdalr3dh.cloudfront.net/image-manager/",
        text: "s3 Image Manager",
        icon: "multi-color-icon-images",
        conditions: [{ variable: "products", key: "s3_image_manager", evaluator: true }],
      },
      {
        link: "https://d45erdalr3dh.cloudfront.net/dashboard/",
        text: "EVO Operations",
        icon: "multi-color-icon-evo",
        conditions: [
          {
            variable: "products",
            key: "evo_operations_panel",
            evaluator: true,
          },
        ],
      },
    ],
  },
  {
    items: [
      {
        link: "#",
        text: "Logout",
        translation: "logout",
        icon: "multi-color-icon-logout",
        function: "logout",
        conditions: [{ variable: "isAuthenticated", evaluator: true }],
      },
    ],
  },
];

export default menuItems;
